import { JobInformation } from '@seek/hirer-job-information';
import { useTranslations } from '@vocab/react';
import {
  Stack,
  Heading,
  Dialog,
  Box,
  Inline,
  ButtonLink,
  IconNewWindow,
  Text,
} from 'braid-design-system';
import { observer } from 'mobx-react';
import type * as React from 'react';

import { useAppConfig } from 'src/constants/AppConfig/AppConfigProvider';
import { trackViewAdPerformanceLinkClickEvent } from 'src/utils/events';

import type { IJob } from '../../../../stores/JobStore/Job';

import translations from './.vocab';

interface Props {
  job: IJob;
  isJobDialogOpen: boolean;
  onClose: () => void;
}

const JobModal = ({ isJobDialogOpen, job, onClose }: Props) => {
  const { t } = useTranslations(translations);
  const { router } = useAppConfig();

  return (
    <Dialog
      id="job-dialog"
      title={t('Ad information')}
      open={isJobDialogOpen}
      onClose={onClose}
      closeLabel={t('Close')}
    >
      <Stack space="large">
        <Stack space="medium">
          <Heading level="4">{t('Ad performance')}</Heading>
          <Box data-testid="job-stats-detail">
            <Inline space={['small', 'medium']}>
              {job.jobInformation.jobId &&
              job.jobInformation.hasPerformanceStats ? (
                <ButtonLink
                  href={router.adPerformance({
                    jobId: job.jobInformation.jobId,
                    ref: 'candiman button',
                  })}
                  target="_blank"
                  variant="ghost"
                  tone="neutral"
                  icon={<IconNewWindow />}
                  onClick={() => trackViewAdPerformanceLinkClickEvent()}
                >
                  {t('View ad performance')}
                </ButtonLink>
              ) : (
                <Text>
                  {t('Performance information is not available for this ad.')}
                </Text>
              )}
            </Inline>
          </Box>
        </Stack>
        <Stack space="medium">
          <Heading level="4">{t('Ad details')}</Heading>
          <JobInformation jobDetails={job.jobDetails} />
        </Stack>
      </Stack>
    </Dialog>
  );
};

export default observer(JobModal);
